import React from 'react';
import { gettext } from '@eb/i18n';

import './OrganizerArticleCardBackground.scss';

const OrganizerArticleCardBackground = ({ image }) => (
    <div className="organizer-article-card__background">
        <img
            className="organizer-article-card__background-image"
            src={image}
            alt={gettext('Organizer article background image')}
        />
    </div>
);

export default OrganizerArticleCardBackground;
